import Button from '@datacamp/waffles-button';
import cx from 'classnames';
import React from 'react';
import { useTranslation } from '../useTranslation';
import { jsx as ___EmotionJSX } from "@emotion/react";
var FeedbackFormFailure = function FeedbackFormFailure(_ref) {
  var buttonLabel = _ref.buttonLabel,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$extraClassName = _ref.extraClassName,
    extraClassName = _ref$extraClassName === void 0 ? '' : _ref$extraClassName,
    onClick = _ref.onClick,
    title = _ref.title;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return ___EmotionJSX("div", {
    className: cx('dc-u-ta-center dc-u-p-32', extraClassName)
  }, ___EmotionJSX("h3", {
    className: "dc-u-mt-16"
  }, title !== null && title !== void 0 ? title : t('FeedbackFormFailure.title')), children, ___EmotionJSX(Button, {
    appearance: "primary",
    className: "u-spacing-t5",
    intent: "success",
    onClick: onClick,
    type: "button"
  }, buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : t('FeedbackFormFailure.button')));
};
FeedbackFormFailure.displayName = 'FeedbackForm.Failure';
export default FeedbackFormFailure;